import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { trackInitiateCheckout } from '../utils/metaPixel';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-surface py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-124" data-mp="1jas22qc1cn10">
      <div className="mx-auto max-w-3xl px-4" data-id="element-125" data-mp="1s9n4rsfvfezk">
        <SectionHeading id="pricing-title" data-id="element-126" data-mp="1s8c1ruu92b9i">Choose Your <span className="text-primary" data-id="element-127" data-mp="1x8qdpnyz25ct">Option</span></SectionHeading>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-primary bg-background shadow-lg" data-id="element-128" data-mp="1x9hwtzbduam7">
          <div className="border-b border-border px-6 py-4 sm:px-10" data-id="element-129" data-mp="225qhfs8cmw0r">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold text-primary" data-id="element-130" data-mp="2w0fwv5hgc05">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-131" data-mp="7vmtx6t4xwa0" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-132" data-mp="1hq80rpq1blxg">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-133" data-mp="1hp6d8lru16yu">
              <div data-id="element-134" data-mp="1crwnt64g0vb0">
                <h3 className="text-2xl font-bold leading-tight tracking-tight text-foreground sm:text-3xl" data-id="element-135" data-mp="1cr4uy328dbof">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-136" data-mp="25fiskhpeq5zg">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-137" data-mp="20h90ifyzbli2">
                <span className="text-sm text-muted" data-id="element-138" data-mp="1vgl7xpv3qwlq">
                  Regular price: <span className="line-through decoration-accent decoration-2" data-id="element-139" data-mp="1rfrkexlknjtd">{priceBefore}</span>
                </span>
                <p className="mt-2 text-sm font-semibold text-accent" data-id="element-140" data-mp="k2g2esf8qeoa">Today:</p>
                <p className="mt-1 whitespace-nowrap text-5xl font-bold leading-none tracking-tight text-accent sm:text-6xl" data-id="element-141" data-mp="g0uhcjsjyu30">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} arrow className="mt-9 w-full" data-id="element-142" data-mp="hfospkn7jo4p">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-medium text-muted" data-id="element-143" data-mp="7lybn0teufz1">
              {['Secure payment', 'Instant access', '7-day guarantee'].map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-144" data-mp="3uul5aufjjvhl">
                  <CheckCircle2Icon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-145" data-mp="3jjqga29r44l" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}